import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutMedia = (titleRef, imgState, linkRef) => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("PUT", `/admin/media/${idx}`, {
            "title": titleRef?.current?.value,
            "img": imgState,
            "url": linkRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate(-1)
                break
            case 400:
                if (fetchResult?.data?.error_code === "media_idx") setAlert("미디어 idx를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "title") setAlert("제목을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "img") setAlert("썸네일 이미지를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "url") setAlert("연결 링크를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("미디어 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePutMedia